export default __webpack_public_path__ + "80b6098c860831d4f27eaced7fe54adf.png";